import { createMultistepForm } from "@app/state/form/multistep";
import { createToast } from "@/modules/toast-message"
import { toFormData } from "@app/helpers/formData";
import { maybeCastValueToString } from "@app/helpers/cast";
import urlProcessor from "@app/helpers/urlProcessor";
import { fields } from "./form/fields";
import { stages } from "./form/stages";

/**
 * Creates the state object for the form
 * 
 * @returns {Object}
 */
export function createForm(){
    return createMultistepForm(
        stages, 
        fields, 
        'bt_create_event_booking',
        {
            responseKey : 'booking',
            callbacks   : {
                onSuccess: [
                    (data) => {
                        if(data.code === 302){
                            window.location.href = data.redirect
                        } else {
                            createToast(data.message ?? 'Booking processed successfully', "success")

                            if(data.data.uuid){
                                window.location.href = urlProcessor(window.location.href, { key: null, success: 1, event_booking: data.data.uuid })
                            }
                        }
                    }
                ],
                onError: [
                    (data) => {
                        if(data.code === 422){
                            createToast("Please check entered data is valid", "error")
                        } else {
                            createToast("An error occurred processing your request, please try again", "error")
                        }
                    } 
                ]
            }
        }
    )
}